{
  "familyId": "TIJD-KALENDER",
  "questions": [
    {
      "id": "TIJD-KALENDER-001",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het maandag 5 maart. Welke dag is het over 7 dagen?",
      "options": ["maandag 12 maart", "zondag 12 maart", "dinsdag 12 maart", "maandag 11 maart"],
      "correctAnswer": 0,
      "conceptId": "calendar_week_later", "variantIndex": 1,
      "citoDifficulty": 0.32, "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "7 dagen verder", "content": "Over 7 dagen is het altijd dezelfde dag van de week. Maandag + 7 = maandag. Datum: 5 + 7 = 12 maart.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Over 7 dagen is het altijd dezelfde dag van de week. Maandag + 7 = maandag. Datum: 5 + 7 = 12 maart.",
        "solutionSteps": ["7 dagen = 1 week → dezelfde dag van de week", "Maandag + 7 dagen = maandag", "Datum: 5 + 7 = 12 maart", "Antwoord: maandag 12 maart"],
        "distractorExplanations": {
          "0": "Goed! Maandag + 7 dagen = maandag 12 maart.",
          "1": "Over 7 dagen is het dezelfde dag van de week (maandag), niet de dag ervoor. 5 + 7 = 12 maart.",
          "2": "Over 7 dagen is het dezelfde dag van de week (maandag), niet de dag erna. 5 + 7 = 12 maart.",
          "3": "De datum klopt niet. 5 + 7 = 12, niet 11. Het is maandag 12 maart."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-002",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het woensdag 10 april. Welke dag is het over 3 dagen?",
      "options": ["zaterdag 13 april", "vrijdag 13 april", "donderdag 13 april", "zaterdag 12 april"],
      "correctAnswer": 0,
      "conceptId": "calendar_days_later", "variantIndex": 2,
      "citoDifficulty": 0.33, "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "3 dagen verder tellen", "content": "Woensdag + 3 dagen: donderdag (1), vrijdag (2), zaterdag (3). Datum: 10 + 3 = 13 april.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Woensdag + 3 dagen: donderdag (1), vrijdag (2), zaterdag (3). Datum: 10 + 3 = 13 april.",
        "solutionSteps": ["Tel de dagen: wo → do (1) → vr (2) → za (3)", "Datum: 10 + 3 = 13 april", "Antwoord: zaterdag 13 april"],
        "distractorExplanations": {
          "0": "Goed! Woensdag + 3 = zaterdag 13 april.",
          "1": "Je hebt maar 2 dagen geteld (donderdag, vrijdag). Maar het zijn 3 dagen: wo → do → vr → za.",
          "2": "Je hebt maar 1 dag geteld. Woensdag + 3 = zaterdag (wo → do → vr → za).",
          "3": "De datum klopt niet. 10 + 3 = 13, niet 12. Het is zaterdag 13 april."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-003",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het dinsdag 8 mei. Welke dag is het over 2 weken?",
      "options": ["dinsdag 22 mei", "dinsdag 15 mei", "woensdag 22 mei", "dinsdag 21 mei"],
      "correctAnswer": 0,
      "conceptId": "calendar_two_weeks_later", "variantIndex": 3,
      "citoDifficulty": 0.34, "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "2 weken verder", "content": "2 weken = 14 dagen. Over 14 dagen is het dezelfde dag van de week (dinsdag). Datum: 8 + 14 = 22 mei.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "2 weken = 14 dagen. Over 14 dagen is het dezelfde dag van de week (dinsdag). Datum: 8 + 14 = 22 mei.",
        "solutionSteps": ["2 weken = 14 dagen", "14 dagen = 2 × 7 → dezelfde dag van de week (dinsdag)", "Datum: 8 + 14 = 22 mei", "Antwoord: dinsdag 22 mei"],
        "distractorExplanations": {
          "0": "Goed! 2 weken = 14 dagen. Dinsdag + 14 = dinsdag 22 mei.",
          "1": "15 mei is over 1 week (7 dagen), niet 2 weken. 2 weken = 14 dagen: 8 + 14 = 22 mei.",
          "2": "Over 14 dagen is het dezelfde dag van de week (dinsdag), niet de dag erna. 8 + 14 = 22 mei.",
          "3": "De datum klopt niet. 8 + 14 = 22, niet 21. Het is dinsdag 22 mei."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-004",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het vrijdag 20 juni. Welke dag is het over 5 dagen?",
      "options": ["woensdag 25 juni", "dinsdag 25 juni", "donderdag 25 juni", "woensdag 24 juni"],
      "correctAnswer": 0,
      "conceptId": "calendar_five_days_later", "variantIndex": 4,
      "citoDifficulty": 0.35, "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "5 dagen verder tellen", "content": "Vrijdag + 5 dagen: zaterdag (1), zondag (2), maandag (3), dinsdag (4), woensdag (5). Datum: 20 + 5 = 25 juni.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Vrijdag + 5 dagen: za (1), zo (2), ma (3), di (4), wo (5). Datum: 20 + 5 = 25 juni.",
        "solutionSteps": ["Tel de dagen: vr → za (1) → zo (2) → ma (3) → di (4) → wo (5)", "Datum: 20 + 5 = 25 juni", "Antwoord: woensdag 25 juni"],
        "distractorExplanations": {
          "0": "Goed! Vrijdag + 5 = woensdag 25 juni.",
          "1": "Je hebt maar 4 dagen geteld. Vrijdag + 5 = woensdag (vr → za → zo → ma → di → wo).",
          "2": "Je hebt 6 dagen geteld in plaats van 5. Vrijdag + 5 = woensdag.",
          "3": "De datum klopt niet. 20 + 5 = 25, niet 24. Het is woensdag 25 juni."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-005",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zaterdag 28 september. Welke dag is het over 4 dagen?",
      "options": ["woensdag 2 oktober", "dinsdag 2 oktober", "woensdag 1 oktober", "donderdag 2 oktober"],
      "correctAnswer": 0,
      "conceptId": "calendar_month_boundary", "variantIndex": 5,
      "citoDifficulty": 0.38, "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Maandgrens overschrijden", "content": "Zaterdag + 4 dagen: zo (1), ma (2), di (3), wo (4). Datum: 28 + 4 = 32. September heeft 30 dagen, dus 32 − 30 = 2 oktober.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Zaterdag + 4 dagen: zo (1), ma (2), di (3), wo (4). Datum: 28 + 4 = 32. September heeft 30 dagen: 32 − 30 = 2 oktober.",
        "solutionSteps": ["Tel de dagen: za → zo (1) → ma (2) → di (3) → wo (4)", "Datum: 28 + 4 = 32", "September heeft 30 dagen → 32 − 30 = 2 oktober", "Antwoord: woensdag 2 oktober"],
        "distractorExplanations": {
          "0": "Goed! Zaterdag + 4 = woensdag 2 oktober.",
          "1": "Je hebt maar 3 dagen geteld. Zaterdag + 4 = woensdag (za → zo → ma → di → wo).",
          "2": "De datum klopt niet. 28 + 4 = 32. September heeft 30 dagen: 32 − 30 = 2 oktober, niet 1.",
          "3": "Je hebt 5 dagen geteld in plaats van 4. Zaterdag + 4 = woensdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-006",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het donderdag 15 februari. Welke dag is het over 14 dagen?",
      "options": ["donderdag 1 maart", "donderdag 29 februari", "vrijdag 1 maart", "donderdag 28 februari"],
      "correctAnswer": 0,
      "conceptId": "calendar_february_boundary", "variantIndex": 6,
      "citoDifficulty": 0.40, "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Februari en maandgrens", "content": "14 dagen = 2 weken → dezelfde dag (donderdag). Datum: 15 + 14 = 29. Februari heeft 28 dagen (gewoon jaar): 29 − 28 = 1 maart.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "14 dagen = 2 weken → dezelfde dag (donderdag). Datum: 15 + 14 = 29. Februari heeft 28 dagen: 29 − 28 = 1 maart.",
        "solutionSteps": ["14 dagen = 2 weken → dezelfde dag van de week (donderdag)", "Datum: 15 + 14 = 29", "Februari heeft 28 dagen (gewoon jaar) → 29 − 28 = 1 maart", "Antwoord: donderdag 1 maart"],
        "distractorExplanations": {
          "0": "Goed! Donderdag + 14 = donderdag 1 maart.",
          "1": "In een gewoon jaar heeft februari maar 28 dagen. 29 februari bestaat niet. 15 + 14 = 29, maar 29 − 28 = 1 maart.",
          "2": "Over 14 dagen is het dezelfde dag van de week (donderdag), niet de dag erna.",
          "3": "De datum klopt niet. 15 + 14 = 29. Februari heeft 28 dagen: 29 − 28 = 1 maart, niet 28 februari."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-007",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het maandag 25 november. Welke dag is het over 10 dagen?",
      "options": ["donderdag 5 december", "woensdag 5 december", "donderdag 4 december", "vrijdag 5 december"],
      "correctAnswer": 0,
      "conceptId": "calendar_ten_days_boundary", "variantIndex": 7,
      "citoDifficulty": 0.37, "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "10 dagen verder met maandgrens", "content": "Maandag + 10 dagen: di(1) wo(2) do(3) vr(4) za(5) zo(6) ma(7) di(8) wo(9) do(10). Datum: 25 + 10 = 35. November heeft 30 dagen: 35 − 30 = 5 december.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Maandag + 10 dagen = donderdag. Datum: 25 + 10 = 35. November heeft 30 dagen: 35 − 30 = 5 december.",
        "solutionSteps": ["Tel de dagen: ma + 10 = ma + 7 + 3 = maandag + 3 = donderdag", "Datum: 25 + 10 = 35", "November heeft 30 dagen → 35 − 30 = 5 december", "Antwoord: donderdag 5 december"],
        "distractorExplanations": {
          "0": "Goed! Maandag + 10 = donderdag 5 december.",
          "1": "Je hebt 9 dagen geteld in plaats van 10. Maandag + 10 = donderdag.",
          "2": "De datum klopt niet. 25 + 10 = 35. November heeft 30 dagen: 35 − 30 = 5 december, niet 4.",
          "3": "Je hebt 11 dagen geteld in plaats van 10. Maandag + 10 = donderdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-008",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zondag 12 juli. Welke dag is het over 3 weken?",
      "options": ["zondag 2 augustus", "zondag 26 juli", "maandag 2 augustus", "zondag 1 augustus"],
      "correctAnswer": 0,
      "conceptId": "calendar_three_weeks_boundary", "variantIndex": 8,
      "citoDifficulty": 0.36, "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "3 weken verder met maandgrens", "content": "3 weken = 21 dagen → dezelfde dag (zondag). Datum: 12 + 21 = 33. Juli heeft 31 dagen: 33 − 31 = 2 augustus.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "3 weken = 21 dagen → dezelfde dag (zondag). Datum: 12 + 21 = 33. Juli heeft 31 dagen: 33 − 31 = 2 augustus.",
        "solutionSteps": ["3 weken = 21 dagen = 3 × 7 → dezelfde dag van de week (zondag)", "Datum: 12 + 21 = 33", "Juli heeft 31 dagen → 33 − 31 = 2 augustus", "Antwoord: zondag 2 augustus"],
        "distractorExplanations": {
          "0": "Goed! Zondag + 21 = zondag 2 augustus.",
          "1": "26 juli is over 2 weken (14 dagen), niet 3 weken. 3 weken = 21 dagen: 12 + 21 = 33, en 33 − 31 = 2 augustus.",
          "2": "Over 21 dagen is het dezelfde dag van de week (zondag), niet de dag erna.",
          "3": "De datum klopt niet. 12 + 21 = 33. Juli heeft 31 dagen: 33 − 31 = 2 augustus, niet 1."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-009",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het woensdag 18 augustus. Welke dag is het over 6 dagen?",
      "options": ["dinsdag 24 augustus", "maandag 24 augustus", "woensdag 24 augustus", "dinsdag 23 augustus"],
      "correctAnswer": 0,
      "conceptId": "calendar_six_days_later", "variantIndex": 9,
      "citoDifficulty": 0.34, "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "6 dagen verder tellen", "content": "Woensdag + 6 dagen: do(1) vr(2) za(3) zo(4) ma(5) di(6). Datum: 18 + 6 = 24 augustus.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Woensdag + 6 dagen: do(1) vr(2) za(3) zo(4) ma(5) di(6). Datum: 18 + 6 = 24 augustus.",
        "solutionSteps": ["Tel de dagen: wo → do (1) → vr (2) → za (3) → zo (4) → ma (5) → di (6)", "Datum: 18 + 6 = 24 augustus", "Antwoord: dinsdag 24 augustus"],
        "distractorExplanations": {
          "0": "Goed! Woensdag + 6 = dinsdag 24 augustus.",
          "1": "Je hebt maar 5 dagen geteld. Woensdag + 6 = dinsdag (wo → do → vr → za → zo → ma → di).",
          "2": "Over 6 dagen is het niet dezelfde dag van de week. Woensdag + 6 = dinsdag.",
          "3": "De datum klopt niet. 18 + 6 = 24, niet 23. Het is dinsdag 24 augustus."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-010",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het vrijdag 29 december. Welke dag is het over 5 dagen?",
      "options": ["woensdag 3 januari", "dinsdag 3 januari", "woensdag 2 januari", "donderdag 3 januari"],
      "correctAnswer": 0,
      "conceptId": "calendar_year_boundary", "variantIndex": 10,
      "citoDifficulty": 0.39, "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Jaargrens overschrijden", "content": "Vrijdag + 5 dagen: za(1) zo(2) ma(3) di(4) wo(5). Datum: 29 + 5 = 34. December heeft 31 dagen: 34 − 31 = 3 januari.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "Vrijdag + 5 dagen: za(1) zo(2) ma(3) di(4) wo(5). Datum: 29 + 5 = 34. December heeft 31 dagen: 34 − 31 = 3 januari.",
        "solutionSteps": ["Tel de dagen: vr → za (1) → zo (2) → ma (3) → di (4) → wo (5)", "Datum: 29 + 5 = 34", "December heeft 31 dagen → 34 − 31 = 3 januari", "Antwoord: woensdag 3 januari"],
        "distractorExplanations": {
          "0": "Goed! Vrijdag + 5 = woensdag 3 januari.",
          "1": "Je hebt maar 4 dagen geteld. Vrijdag + 5 = woensdag (vr → za → zo → ma → di → wo).",
          "2": "De datum klopt niet. 29 + 5 = 34. December heeft 31 dagen: 34 − 31 = 3 januari, niet 2.",
          "3": "Je hebt 6 dagen geteld in plaats van 5. Vrijdag + 5 = woensdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-011",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het dinsdag 20 oktober. Welke dag is het over 1 week?",
      "options": ["dinsdag 27 oktober", "woensdag 27 oktober", "dinsdag 26 oktober", "maandag 27 oktober"],
      "correctAnswer": 0,
      "conceptId": "calendar_one_week_later", "variantIndex": 11,
      "citoDifficulty": 0.32, "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "1 week verder", "content": "1 week = 7 dagen. Over 7 dagen is het altijd dezelfde dag van de week (dinsdag). Datum: 20 + 7 = 27 oktober.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "1 week = 7 dagen. Over 7 dagen is het dezelfde dag van de week (dinsdag). Datum: 20 + 7 = 27 oktober.",
        "solutionSteps": ["1 week = 7 dagen → dezelfde dag van de week", "Dinsdag + 7 dagen = dinsdag", "Datum: 20 + 7 = 27 oktober", "Antwoord: dinsdag 27 oktober"],
        "distractorExplanations": {
          "0": "Goed! Dinsdag + 7 = dinsdag 27 oktober.",
          "1": "Over 7 dagen is het dezelfde dag van de week (dinsdag), niet de dag erna. 20 + 7 = 27 oktober.",
          "2": "De datum klopt niet. 20 + 7 = 27, niet 26. Het is dinsdag 27 oktober.",
          "3": "Over 7 dagen is het dezelfde dag van de week (dinsdag), niet de dag ervoor. 20 + 7 = 27 oktober."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-012",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11, "levelCode": "E7", "group": 7,
      "skill": "tijdrekenen", "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zaterdag 30 april. Welke dag is het over 8 dagen?",
      "options": ["zondag 8 mei", "zaterdag 8 mei", "zondag 7 mei", "maandag 8 mei"],
      "correctAnswer": 0,
      "conceptId": "calendar_eight_days_boundary", "variantIndex": 12,
      "citoDifficulty": 0.36, "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "8 dagen verder met maandgrens", "content": "8 = 7 + 1 dag. Zaterdag + 1 = zondag. Datum: 30 + 8 = 38. April heeft 30 dagen: 38 − 30 = 8 mei.", "icon": "lightbulb" } }],
      "feedback": {
        "explanationText": "8 = 7 + 1. Zaterdag + 1 extra dag = zondag. Datum: 30 + 8 = 38. April heeft 30 dagen: 38 − 30 = 8 mei.",
        "solutionSteps": ["8 dagen = 7 + 1 → 1 week + 1 dag extra", "Zaterdag + 1 dag = zondag", "Datum: 30 + 8 = 38. April heeft 30 dagen → 38 − 30 = 8 mei", "Antwoord: zondag 8 mei"],
        "distractorExplanations": {
          "0": "Goed! Zaterdag + 8 = zondag 8 mei.",
          "1": "Over 7 dagen is het dezelfde dag (zaterdag), maar het zijn 8 dagen. 8 = 7 + 1, dus 1 dag verder = zondag.",
          "2": "De datum klopt niet. 30 + 8 = 38. April heeft 30 dagen: 38 − 30 = 8 mei, niet 7.",
          "3": "Je hebt 9 dagen geteld in plaats van 8. Zaterdag + 8 = zondag."
        }
      }
    }
  ]
}